var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ticket)?_c('div',{attrs:{"dir":_vm.localDisplayLang === 'ara' ? 'rtl' : 'ltr'}},[_c('ticketHistory',{attrs:{"ticket":_vm.ticket,"closePopup":_vm.closePopup},on:{"dismissPopup":_vm.dismissPopup}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }